import { required, numeric, integer, minValue, maxValue, helpers } from '@vuelidate/validators';
import i18n from "@/plugins/i18n";

export default function (formState) {
  return {
    item: {
      inventory_id: {
        required: helpers.withMessage(i18n.global.t('Please select an ingredient.'), required)
      },
      quantity: {
        required: helpers.withMessage(i18n.global.t('Please enter a quantity.'), required),
        numeric: helpers.withMessage(i18n.global.t('Please enter a valid number for the quantity.'), numeric),
        minValue: helpers.withMessage(i18n.global.t('Quantity must be greater than 0.'), minValue(0.0001))
      },
      unit_id: {
        required: helpers.withMessage(i18n.global.t('Please select a unit.'), required),
        integer: helpers.withMessage(i18n.global.t('Please enter a valid number.'), integer)
      },
      shelf_life_value: {
        required: helpers.withMessage(i18n.global.t('Please enter a shelf life value.'), required),
        integer: helpers.withMessage(i18n.global.t('Please enter a valid number.'), integer),
        minValue: helpers.withMessage(i18n.global.t('Value must be at least 1.'), minValue(1)),
        maxValue: helpers.withMessage(i18n.global.t('Value cannot exceed 100.'), maxValue(100))
      },
      shelf_life_unit: {
        required: helpers.withMessage(i18n.global.t('Please select a shelf life unit.'), required)
      },
      cost_allocation_percent: {
        required: helpers.withMessage(i18n.global.t('Please enter a cost allocation.'), required),
        numeric: helpers.withMessage(i18n.global.t('Please enter a valid number.'), numeric),
        minValue: helpers.withMessage(i18n.global.t('Value must be at least 0.'), minValue(0)),
        maxValue: helpers.withMessage(i18n.global.t('Value cannot exceed 100.'), maxValue(100))
      }
    }
  }
};
